// src/pages/ForgotPassword.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import toastr from "toastr";

const API   = "https://backend.suvidhape.in/api/v1/auth";
const toast = (m, t = "success") => {
  toastr.options = { closeButton: true, progressBar: true, timeOut: 3000 };
  toastr[t](m);
};

export default function ForgotPassword() {
  /* step: 1 = ask email/mobile, 2 = OTP + new pwd, 3 = done */
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ id: "", otp: "", pwd: "", pwd2: "" });
  const [loading, setLoading] = useState(false);

  const change = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  /* ------------- step‑1  OTP send ------------- */
  const sendOTP = async (e) => {
    e.preventDefault();
    if (!form.id.trim()) return toast("Enter email or mobile", "error");

    setLoading(true);
    try {
      const r = await fetch(`${API}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email_or_mobile: form.id.trim() }),
      });
      if (!r.ok) throw new Error("Send failed");
      toast("OTP sent ✔");
      setStep(2);
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  /* ------------- step‑2  Reset password ------------- */
  const resetPwd = async (e) => {
    e.preventDefault();
    if (form.pwd !== form.pwd2)
      return toast("Passwords do not match", "error");
    if (!form.otp.trim()) return toast("Enter OTP", "error");

    setLoading(true);
    try {
      const r = await fetch(`${API}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email_or_mobile: form.id.trim(),
          otp: form.otp.trim(),
          new_password: form.pwd,
        }),
      });
      if (!r.ok) throw new Error("Reset failed");
      toast("Password updated ✔");
      setStep(3);
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  /* ------------- success screen ------------- */
  if (step === 3)
    return (
      <div className="wrapper d-flex align-items-center justify-content-center vh-100">
        <div className="text-center">
          <h4>Password changed successfully</h4>
          <Link to="/" className="btn btn-primary mt-3">
            Back to Login
          </Link>
        </div>
      </div>
    );

  /* ------------- main UI ------------- */
  return (
    <div className="wrapper">
      <div className="authentication-forgot d-flex align-items-center justify-content-center">
        <div className="card shadow-lg forgot-box">
          <div className="card-body p-md-5">
            <div className="text-center mb-4">
              <img src="assets/images/icons/forgot-2.png" width={140} alt="" />
            </div>

            <h4 className="font-weight-bold">
              {step === 1 ? "Forgot Password?" : "Reset Password"}
            </h4>
            <p className="text-muted mb-3">
              {step === 1
                ? "Enter your registered email or mobile to receive OTP"
                : "Enter the OTP and your new password"}
            </p>

            <form onSubmit={step === 1 ? sendOTP : resetPwd}>
              {/* --- step 1 fields --- */}
              {step === 1 && (
                <div className="mb-3">
                  <label className="form-label">Email / Mobile</label>
                  <input
                    name="id"
                    value={form.id}
                    onChange={change}
                    className="form-control form-control-lg radius-30"
                    placeholder="example@user.com / 9876543210"
                    required
                  />
                </div>
              )}

              {/* --- step 2 fields --- */}
              {step === 2 && (
                <>
                  <div className="mb-3">
                    <label className="form-label">OTP</label>
                    <input
                      name="otp"
                      value={form.otp}
                      onChange={change}
                      className="form-control radius-30"
                      placeholder="Enter OTP"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      name="pwd"
                      value={form.pwd}
                      onChange={change}
                      className="form-control radius-30"
                      placeholder="New password"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Repeat Password</label>
                    <input
                      type="password"
                      name="pwd2"
                      value={form.pwd2}
                      onChange={change}
                      className="form-control radius-30"
                      placeholder="Repeat password"
                      required
                    />
                  </div>
                </>
              )}

              {/* buttons */}
              <div className="d-grid gap-2">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg radius-30"
                  disabled={loading}
                >
                  {loading
                    ? "Please wait…"
                    : step === 1
                    ? "Send OTP"
                    : "Reset Password"}
                </button>
                <Link to="/" className="btn btn-light radius-30">
                  <i className="bx bx-arrow-back me-1" />
                  Back to Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
